<template>
	<div>
		<ul>
			<li v-for="lang in languages" :key="lang" @click="changeLang(lang)">{{lang}}</li>

		</ul>
	</div>
</template>

<script>
	export default {
		props: [],
		data: function () {
			return {
				languages: ['de', 'en']
			}
		},
		methods: {
			changeLang: function (lang) {
				this.$i18n.locale = lang;
			}
		},
		components: {}
	}
</script>

<style scoped lang="scss">

</style>
